import { FileInput } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Bốn quy tắc của Yêu cầu mua hàng — anh Toàn chốt 19/09/2026 theo chuẩn (PR-R01..R03 + ai được làm gì), khách bác lại được. Trước đây
 * là ba thẻ vàng "chờ khách xác nhận" và một nút bật chế độ rà quy tắc ở danh sách; nay là một mục gập trung tính.
 */
export const REQUISITION_RULES_SETTLED = ["need", "approval", "closure", "authority"] as const;

export function RequisitionRules() {
  return <SettledRules ns="requisitions" rules={REQUISITION_RULES_SETTLED} icon={FileInput} />;
}

/** Cùng bộ giải quyền với máy chủ — chỉ để khỏi vẽ nút mà bấm vào là 403. Người lập không tự duyệt thì máy chủ vẫn chặn riêng. */
export function useRequisitionAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (verb: AccessVerb) => !!access && canAccess(access, "requisitions", verb);
}
